import React, { useState } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material'
import { Close } from '@mui/icons-material'
import { IStatusJob } from '../../Rubros/Entrenamiento'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'

const DialogStatusJob: React.FC<{
  open: boolean
  setOpen: (op: boolean) => void
  statusJob: IStatusJob
}> = ({ open, setOpen, statusJob }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  if (!statusJob) return
  return (
    <>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          {`${statusJob.jobName} (${statusJob.jobId})`}
          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            sx={{
              color: (theme) => theme.palette.grey[500],
              position: 'absolute',
              right: 8,
              top: 8
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <Typography>Status: {statusJob.status}</Typography>
          {statusJob.statusReason && <Typography>Razón: {statusJob.statusReason}.</Typography>}
          {statusJob.createdAt && (
            <Typography>{`Creado el ${format(statusJob.createdAt, 'dd/MM/yyyy HH:mm', { locale: es })}`}</Typography>
          )}
          {statusJob.startedAt && (
            <Typography>{`Comenzó el ${format(statusJob.startedAt, 'dd/MM/yyyy HH:mm', { locale: es })}`}</Typography>
          )}
          {statusJob.stoppedAt && (
            <Typography>
              {`Finalizó el ${format(statusJob.stoppedAt, 'dd/MM/yyyy HH:mm', {
                locale: es
              })}`}
            </Typography>
          )}
          {statusJob.durationSeconds && <Typography>{`Tardó ${statusJob.durationSeconds} segundos.`}</Typography>}
        </DialogContent>
      </Dialog>
    </>
  )
}

export default DialogStatusJob
